import { Table } from 'antd'
import { Trans } from "@lingui/macro"
import { formatNum } from "utils"
import { useState } from 'react'
import useTrendingTopic from './hooks/useTrendingTopic'

const TrendingTopics = () => {
  const [page, setPage] = useState(1)
  const [{ list, total }, loading] = useTrendingTopic(page)
  const columns: any = [
    {
      title: '#',
      dataIndex: '',
      key: 'key',
      width: 100,
      render: (_cur: any, _record: any, index: number) => (<div>{(index + 1)+(page-1)*8}</div>)
    },
    {
      title: <div><Trans>Topic</Trans></div>,
      dataIndex: 'topic',
      key: 'topic',
      ellipsis: true,
      width: 180,
      render: (cur: any) => (
        <div className="flex items-center">
          <div className="truncate">
            {/* <Tooltip placement="topLeft" title={cur}> */}
              #{cur?.toUpperCase()}
            {/* </Tooltip> */}
          </div>
        </div>
      )
    },
    {
      title: <div><Trans>Engagement (24H)</Trans></div>,
      dataIndex: 'value',
      key: 'value',
      width: 120,
      render: (cur: any) => (<div>{formatNum(cur)}</div>)
    },
  ]
  const handleTableChange = (pagination: any) => {
    setPage(pagination.current)
  }
  return (
    <div className="container mx-auto max-w-6.5xl">
      <div className="bg-con rounded pt-4">
        <div className="text-xl font-medium pl-3"><Trans>Trending Topics</Trans></div>
        <div className="mt-4 md:mt-4 py-1 overflow-x-scroll">
          <Table className="" loading={loading as boolean} dataSource={list} columns={columns}
            rowKey={(record) => record.topic}
            rowClassName={(_, index) => {
              let className = 'rodd'
              if (index % 2 === 0) className = 'reven'
              return className
            }}
            pagination={{
              position: ['bottomCenter'],
              showSizeChanger: false,
              size: 'small',
              current: page,
              pageSize: 8,
              total: total > 40 ? 40 : total,
            }}
            onChange={handleTableChange}
          />
        </div>
      </div>
    </div>
  )
}

export default TrendingTopics
